import axios from 'axios';

class BlanksProvider {
    constructor(url) {
        this.url = url;
    }

    getBlank(accessToken, thirdPartyCode) {
        return axios.get(`${this.url.blank_info}/admin/blanks`, {
            headers: {
                'X-Employee-Auth': accessToken,
            },
            params: {
                'third_party_code': thirdPartyCode
            }
        }).then((response) => {
            const data = response.data;
            const blank = data.data[0];
            return axios.get(`${this.url.blank_pdf}/getBatchLetterIndividualPDF?id=${blank.post_kz_blank_id}`, {
                responseType: 'blob',
                transformResponse:
                    [function (data) {
                        let blob = new window.Blob([data], {type: 'application/pdf'})
                        return window.URL.createObjectURL(blob)
                    }]
            });
        })
    }
}

const getBlanksProvider = (url) => {
    return new BlanksProvider(url);
}

export { getBlanksProvider };
